import { useLicence, canAccess } from '../contexts/LicenceContext';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function UpgradeGate({ feature, children, featureName }) {
  const licence = useLicence();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (canAccess(licence, feature)) return children;

  const tierName = licence?.licence_tier || 'Basic';

  return (
    <div className="relative flex-1" data-testid={`upgrade-gate-${feature}`}>
      <div className="opacity-30 pointer-events-none select-none filter blur-[2px]">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center z-50">
        <div className="bg-white/95 backdrop-blur-sm border border-[#E5E7E1] rounded-2xl shadow-xl p-8 text-center max-w-sm mx-4">
          <div className="w-14 h-14 rounded-full bg-[#F5F7F0] flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-[#556B2F]" />
          </div>
          <h2 className="text-xl font-bold text-[#1A2421] mb-2" style={{ fontFamily: 'Outfit' }}>
            {t('upgrade.featureNotAvailable', { feature: featureName || feature })}
          </h2>
          <p className="text-sm text-[#5C6656] mb-5">
            {t('upgrade.upgradeToUnlock', { tier: tierName })}
          </p>
          <Button onClick={() => navigate('/settings')} className="bg-[#556B2F] hover:bg-[#4A5D23] text-white px-6" data-testid="upgrade-gate-btn">
            {t('upgrade.viewPlans')}
          </Button>
        </div>
      </div>
    </div>
  );
}
